// extracted by mini-css-extract-plugin
export default {"description":"styles_description__PpfPj","eventsElement":"styles_eventsElement__myOOh"};